import cls from 'classnames';
import styles from './index.module.scss';
export default () => {
  return (
    <div className={cls(styles['index-header'], 'flex')}>
      <div className={cls(styles['header-center'], 'flex1')}>首页</div>
    </div>
  );
};
